<ng-content />
<ion-icon *ngIf="coreMarkRequired" class="core-input-required-asterisk" name="fas-circle-exclamation" color="danger"
    [attr.aria-label]="requiredLabel" />
